import { useState } from "react";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import DoneOutlineTwoToneIcon from "@material-ui/icons/DoneOutlineTwoTone";

const details = [
  " Offer valid until end Sept 2021",
  "Prices valid from Sunday to Thursday",
  "Based on a 30pax group",
  "Twin Room accommodated",
  "All meals include wine and coffee",
  "Basic AAVV and coffee break incl in the meeting space",
];

export default function Conditions() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div>
      <Typography
        aria-owns={open ? "mouse-over-popover" : undefined}
        aria-haspopup='true'
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        variant='h6'
      >
        Package details
      </Typography>
      <Popover
        id='mouse-over-popover'
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <ul>
          {details.map((detail) => (
            <li className={classes.list} key={detail}>
              <DoneOutlineTwoToneIcon />
              {detail}
            </li>
          ))}
        </ul>
      </Popover>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(1),
  },
  list: {
    listStyleType: "none",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    "& .MuiSvgIcon-root": {
      color: "green",
      marginRight: theme.spacing(2),
    },
  },
}));
